export function shouldShowTrainingCalories(
  totalCalories: number | null | undefined,
): boolean {
  return totalCalories != null;
}

export function hasTrainingCaloriesData(
  trainings: Array<{ totalCalories?: number | null }>,
): boolean {
  return trainings.some((training) =>
    shouldShowTrainingCalories(training.totalCalories),
  );
}

export function formatTrainingCalories(totalCalories: number): string {
  return `${Math.round(totalCalories)}`;
}
